import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-close',
    templateUrl: '../svgs/Close.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--close'
    }
})
export class TellerOnlineIconClose {
}